var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEB\xA9\x94\xEB\x89\xB4\xEB\xB2\x84\xED\x8A\xBC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xEB\xA9\x94\xEB\x89\xB4\xEB\xB2\x84\xED\x8A\xBC_2"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 4",
    x1: 2,
    y1: 6.5,
    x2: 28,
    y2: 6.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 5",
    x1: 2,
    y1: 14.5,
    x2: 28,
    y2: 14.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 6",
    x1: 2,
    y1: 22.5,
    x2: 28,
    y2: 22.5,
    stroke: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderMenuIcon);
export default __webpack_public_path__ + "static/media/headerMenuIcon.234faf175e8f2fae6ab98c6665287d6d.svg";
export { ForwardRef as ReactComponent };